var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 60,
  viewBox: "0 0 64 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M32 0c17.673 0 32 11.49 32 25.665S49.673 51.331 32 51.331c-1.585 0-3.144-.093-4.667-.271L11.687 60l-.001-14.503C4.551 40.79 0 33.654 0 25.665 0 11.491 14.327 0 32 0"
})));
export default SvgChannelMessage;